import { Grid, theme } from '@zappyrent/hundop';
import Media from 'react-media';

import { StyledWrapper } from './Main.styles';
import { IMainProps } from './Main.types';

const Main = ({ children }: IMainProps): JSX.Element => {
  return (
    <StyledWrapper>
      <Media
        queries={{
          mobile: `(max-width: calc(${theme.breakpoints.l} - 1px))`,
          desktop: `(min-width: ${theme.breakpoints.l})`,
        }}
      >
        {matches => (
          <>
            {matches.desktop && children}
            {matches.mobile && (
              <Grid container direction="column">
                {children}
              </Grid>
            )}
          </>
        )}
      </Media>
    </StyledWrapper>
  );
};

export default Main;
